/**
 * Utilitaires pour les graphiques
 */

import { CHART_COLORS, CHART_LABELS } from '../constants/chartConstants'

/**
 * Génère une couleur pastel basée sur une chaîne de caractères
 */
export const stringToPastelColor = (str) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  let color = 'hsl(' + (hash % 359) + ', 50%, 80%)'
  return color
}

/**
 * Réduit plusieurs tableaux en un seul en additionnant les valeurs
 */
export const reduceLog = (arrays) => {
  let result = []

  // Déterminer la longueur du tableau résultat en prenant la longueur du plus grand tableau dans la liste
  let maxLength = 0
  for (let i = 0; i < arrays.length; i++) {
    maxLength = Math.max(maxLength, arrays[i].length)
  }

  // Initialiser le tableau résultat avec des zéros
  for (let i = 0; i < maxLength; i++) {
    result.push(0)
  }

  // Ajouter les valeurs des tableaux
  for (let i = 0; i < arrays.length; i++) {
    for (let j = 0; j < arrays[i].length; j++) {
      if (arrays[i][j]) {
        result[j] += arrays[i][j]
      }
    }
  }

  return result
}

/**
 * Valide les données KPI pour un type donné
 */
export const validateKpiData = (kpiDocument, name) => {
  return kpiDocument[name] &&
         kpiDocument[name].result &&
         kpiDocument[name].result.fields &&
         kpiDocument[name].result.rows
}

/**
 * Obtient les données par défaut pour un type de KPI
 */
export const getDefaultKpiData = (name) => {
  const defaults = {
    er_supervise: {
      result: { fields: ['in_prod', 'out_prod'], rows: [1, 1] }
    },
    mitre_attack: {
      result: { fields: [''], rows: [[0, 0]] }
    },
    perimetre_supervise: {
      result: { fields: [''], rows: [0] }
    },
    log: {
      result: {
        fields: ['_time', 'Total', '_span', '_spandays'],
        rows: ['2025-01-09T00:00:00.000+01:00', 0, 0, 0],
      }
    }
  }
  
  return defaults[name] || { result: { fields: [], rows: [] } }
}

/**
 * Obtient les labels traduits pour un type de KPI
 */
export const getTranslatedLabels = (fields, type) => {
  if (type === 'er_supervise') {
    return fields.map(label => CHART_LABELS[label] || label)
  }
  return fields
}

/**
 * Obtient les couleurs pour un type de KPI
 */
export const getColorsForKpi = (fields, type) => {
  switch (type) {
    case 'er_supervise':
      return fields.map(field => CHART_COLORS[field])
    case 'perimetre_supervise':
      return fields.map((_, i) => CHART_COLORS.pr[i % CHART_COLORS.pr.length])
    case 'mitre_attack':
      return [CHART_COLORS.en_production, CHART_COLORS.hors_production]
    case 'log':
      return CHART_COLORS.log
    default:
      return []
  }
}

/**
 * Traite les données de logs pour les graphiques
 */
export const processLogData = (kpiDocument, stacked, currentUser) => {
  const datasets = []
  
  if (stacked === true) {
    // Mode empilé
    for (var i = 1; i < kpiDocument.log.result.fields.length; i++) {
      var data = kpiDocument.log.result.rows.map((row, ii) => {
        if (row && row.length > 0) return row[i]
      })
      datasets.push({
        label: kpiDocument.log.result.fields[i].replace('_', ' '),
        type: 'bar',
        stack: 'Base',
        backgroundColor: CHART_COLORS.log[i - 1],
        data: data,
      })
    }
  } else {
    // Mode groupé
    let tabCategoriesLogs = []
    for (var i = 1; i < kpiDocument.log.result.fields.length; i++) {
      var data = kpiDocument.log.result.rows.map((row, ii) => {
        if (row && row.length > 0) return row[i]
      })
      let categLog = kpiDocument.log.result.fields[i].replace('_', ' ')
      if (categLog == 'SHEM OME') {
        categLog = 'SHEM'
      }
      const found = (uneCateg) => uneCateg.label == categLog
      const indexCateg = tabCategoriesLogs.findIndex(found)
      if (indexCateg == -1) {
        for (let i = 0; i < data.length; i++) {
          if (i == 0) {
            tabCategoriesLogs.push({ label: categLog, data: [data[i]] })
          } else {
            tabCategoriesLogs[tabCategoriesLogs.length - 1].data.push(data[i])
          }
        }
      } else {
        for (let i = 1; i < data.length; i++) {
          tabCategoriesLogs[indexCateg].data[i] += data[i]
        }
      }
    }
    
    const sumArray = []
    for (let i = 0; i < tabCategoriesLogs.length; i++) {
      sumArray.push(tabCategoriesLogs[i].data.map((number) => number))
    }
    
    if (currentUser) {
      datasets.push({
        label: 'all',
        type: 'bar',
        stack: 'Base',
        backgroundColor:
          currentUser.firstname && currentUser.lastname
            ? stringToPastelColor(
                currentUser.firstname + ' ' + currentUser.lastname,
              )
            : CHART_COLORS.log[1],
        data: reduceLog(sumArray),
      })
    }
  }
  
  const labels = kpiDocument.log.result.rows.map((row, i) => {
    if (row && row.length > 0) return row[0]
  })
  
  return { datasets, labels }
}
